import { createRouter, createWebHistory } from "vue-router";
import store from "./store";
const routes = [
  {
    path: "/",
    name: "Home",
    exact: true,
    component: () => import("./pages/Login.vue"),
    meta: {
      requiresAuth: false,
    },
  },

  {
    path: "/login",
    name: "Login",
    exact: true,
    component: () => import("./pages/Login.vue"),
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: "/forgotpassword",
    name: "ForgotPassword",
    exact: true,
    component: () => import("./pages/ForgotPassword.vue"),
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    exact: true,
    component: () => import("./pages/Dashboard.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/users",
    name: "Users",
    exact: true,
    component: () => import("./pages/Users.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/clients",
    name: "clients",
    exact: true,
    component: () => import("./pages/Clients.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/products",
    name: "products",
    exact: true,
    component: () => import("./pages/Products.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/endClients",
    name: "endClients",
    exact: true,
    component: () => import("./pages/EndClients.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/vendor",
    name: "vendor",
    exact: true,
    component: () => import("./pages/Vendor.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/govApiSettings",
    name: "govApiSettings",
    exact: true,
    component: () => import("./pages/GovApiSettings.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/myprofile",
    name: "MyProfile",
    component: () => import("./pages/MyProfile.vue"),

    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/services",
    name: "Services",
    component: () => import("./pages/Services.vue"),

    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/apiconsumption",
    name: "ApiConsumption",
    component: () => import("./pages/ApiCallHistory.vue"),

    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/companysenderid/smssenderid/:id",
    name: "SMSSenderId",
    component: () => import("./pages/SenderId.vue"),

    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/companysenderid",
    name: "companysenderid",
    component: () => import("./pages/companySenderId.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/D_I_D/Numbers/free-numbers",
    name: "freeNumbers",
    component: () => import("./pages/cloudtelephony/freeDIDNumbers.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/D_I_D/Numbers/admin-numbers",
    name: "adminNumbers",
    component: () => import("./pages/cloudtelephony/adminDIDNumbers.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/D_I_D/Numbers/notice-period",
    name: "underNoticePeriodNumbers",
    component: () => import("./pages/cloudtelephony/underNoticePeriodNumbers.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/D_I_D/Numbers/submitted-request-to-operator",
    name: "submittedRequestToOperator",
    component: () => import("./pages/cloudtelephony/requestSubmittedToOperator.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/D_I_D/Numbers/released-numbers",
    name: "releasedNumbers",
    component: () => import("./pages/cloudtelephony/releasedNumbers.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/identity-verification",
    name: "verifications",
    component: () => import("./pages/Verification.vue"),
    meta: { requiresAuth: false, publicOnly: true },
  },

  // {
  //   path: "/underprogress",
  //   name: "underprogress",
  //   exact: true,
  //   component: () => import( "./pages/UnderProgress.vue" ),
  //   meta: {
  //     requiresAuth: true,
  //   },
  // },

  {
    path: "/:pathMatch(.*)",
    name: "notfound",
    component: () => import("./pages/NotFound"),
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: "/underprogress",
    name: "underprogress",
    exact: true,
    component: () => import("./pages/UnderProgress.vue"),
    meta: {
      requiresAuth: true,
    },
  },
    {
    path: "/billing/clientbilling",
    name: "clientbilling",
    exact: true,
    component: () => import("./pages/billing/Billing.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/billing/taxinvoice",
    name: "taxinvoice",
    exact: true,
    component: () => import("./pages/billing/TaxInvoice.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/billing/paymentreceipt",
    name: "paymentreceipt",
    exact: true,
    component: () => import("./pages/billing/PaymentReceipt.vue"),
    meta: {
      requiresAuth: true,
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});
router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  const publicOnly = to.matched.some((record) => record.meta.publicOnly); // <- added check
  const checkModuleAccess = to.matched.some(
    (record) => record.meta.checkModuleAccess
  );
  const moduleId = to.meta.moduleId;

  // Only check credentials if the route needs auth
  if (requiresAuth) {
    await store.dispatch("checkLoginCredentials");
  }

  const authenticatedUser = store.state.loggedInUserSessions.user_reference;
  const permission_fks = store.state.loggedInUserSessions.permission_fks || [];

  // Block access to protected routes if no user
  if (requiresAuth && !authenticatedUser) {
    return next("/login");
  }

  // Always allow public-only routes like /identity-verification
  if (publicOnly) {
    return next();
  }

  // If module-level permission check is needed
  if (checkModuleAccess) {
    if (permission_fks.includes(moduleId)) {
      return next();
    } else {
      return next(false); // block if no permission
    }
  }

  // Default: allow access
  return next();
});

export default router;
